import { makeHttpRequest } from "@/shared";

export const deleteContracts = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "order/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;

    return response;
};
